import schoolList from '@/views/schoolManage/schoolList';
import schoolListAbc from '@/views/schoolManage/schoolListAbc';
import schoolListCcb from '@/views/schoolManage/schoolListCcb';
import schoolAdd from '@/views/schoolManage/schoolAdd';
import schoolEdit from '@/views/schoolManage/schoolEdit';
import schoolDetail from '@/views/schoolManage/schoolDetail';
import schoolPermission from '@/views/schoolManage/schoolPermission';
import schoolGrant from '@/views/schoolManage/schoolGrant';
import schoolIntGrant from '@/views/schoolManage/schoolIntGrant';
import newOrderList from '@/views/schoolManage/newOrderList';
import activatingCodeList from '@/views/schoolManage/activatingCodeList';
import externalContact from '@/views/schoolManage/externalContact';
import appInsertIndex from '@/views/appInsert/appInsertIndex';
import schoolModuleRolePermissionList
    from '@/views/schoolManage/schoolModuleRolePermission/schoolModuleRolePermissionList';
import schoolModuleRolePermissionAdd
    from '@/views/schoolManage/schoolModuleRolePermission/schoolModuleRolePermissionAdd';
import schoolModuleRolePermissionEdit
    from '@/views/schoolManage/schoolModuleRolePermission/schoolModuleRolePermissionEdit';

import schoolRoleList from '@/views/schoolManage/schoolRole/schoolRoleList';
import schoolRoleEdit from '@/views/schoolManage/schoolRole/schoolRoleEdit';
import schoolRoleUserList from '@/views/schoolManage/schoolRole/schoolRoleUserList';

import schoolAppList from '@/views/schoolManage/schoolAppManage/schoolAppList';
import schoolAppInteDetail from '@/views/schoolManage/schoolAppManage/schoolAppInteDetail';

import schoolAdmin from '@/views/schoolManage/schoolAdmin';

import schoolSuite from '@/views/schoolManage/schoolSuite';

import promoteGrade from '@/views/schoolManage/promoteGrade';
//平台商户
import platformmerchantindex from '@/views/platformmerchant/platformmerchantindex';
import platformmerchantadd from '@/views/platformmerchant/platformmerchantadd';
import platformmerchanteidt from '@/views/platformmerchant/platformmerchanteidt';
import platformmerchantlist from '@/views/platformmerchant/platformmerchantlist';
import merchantstatistics from '@/views/platformmerchant/merchantstatistics';
import merchantstatisticslist from '@/views/platformmerchant/merchantstatisticslist';
import cashoutreconciliation from '@/views/platformmerchant/cashoutreconciliation';
import cashoutreconciliationinfo from '@/views/platformmerchant/cashoutreconciliationinfo';
export default [
    {
        path: 'iPayment',
        redirect: 'iPayment/homePage'
    },
    {
        path: 'iPayment/homePage',
        component: () => import('@/views/iPayment/homePage/index2')
    },
    {
        path: 'iPayment/merchantMan',
        redirect: 'iPayment/merchantMan/merchantIndex'
    },
    // 商户列表
    {
        path: 'iPayment/merchantMan/merchantIndex',
        component: () => import('@/views/iPayment/merchantMan/merchantList/merchantIndex')
    },
    {
        path: 'iPayment/merchantMan/merchantAdd',
        component: () => import('@/views/iPayment/merchantMan/merchantList/merchantAdd')
    },
    {
        path: 'iPayment/merchantMan/merchantEidt',
        component: () => import('@/views/iPayment/merchantMan/merchantList/merchantEidt')
    },
    {
        path: 'iPayment/merchantMan/configurationList',
        component: () => import('@/views/iPayment/merchantMan/merchantList/configurationList')
    },
    {
        path: 'iPayment/merchantMan/configurationAdd',
        component: () => import('@/views/iPayment/merchantMan/merchantList/configurationAdd')
    },
    {
        path: 'iPayment/merchantMan/configurationInfo',
        component: () => import('@/views/iPayment/merchantMan/merchantList/configurationInfo')
    },
    {
        path: 'iPayment/merchantMan/configurationEidt',
        component: () => import('@/views/iPayment/merchantMan/merchantList/configurationEidt')
    },
    {
        path: 'iPayment/merchantMan/merchantAssociationIndex',
        component: () => import('@/views/iPayment/merchantMan/merchantAssociation/merchantAssociationIndex')
    },
    {
        path: 'iPayment/merchantMan/merchantAssociationAdd',
        component: () => import('@/views/iPayment/merchantMan/merchantAssociation/merchantAssociationAdd')
    },
    {
        path: 'iPayment/merchantMan/merchantAssociationEidt',
        component: () => import('@/views/iPayment/merchantMan/merchantAssociation/merchantAssociationEidt')
    },
    {
        path: 'iPayment/merchantMan/testpaymentIndex',
        component: () => import('@/views/iPayment/merchantMan/testpayment/testpaymentIndex')
    },

    {
        path: 'iPayment/fundStatement',
        redirect: 'iPayment/fundStatement/runningTab'
    },
    // 交易流水
    {
        path: 'iPayment/fundStatement/runningTab',
        component: () => import('@/views/iPayment/fundStatement/runningTab'),
        meta: {
            isCached: true
        }
    },
    // 平台对账
    {
        path: 'iPayment/fundStatement/platformReconciliation',
        component: () => import('@/views/iPayment/fundStatement/platformReconciliation'),
        meta: {
            isCached: true
        }
    },
    // 银行对账
    {
        path: 'iPayment/fundStatement/bankReconciliation',
        component: () => import('@/views/iPayment/fundStatement/bankReconciliation'),
        meta: {
            isCached: true
        }
    },
    // 对账明细
    {
        path: 'iPayment/fundStatement/bankReconciliationDetail',
        component: () => import('@/views/iPayment/fundStatement/bankReconciliation/reconciliationDetail')
    },
    {
        path: 'iPayment/fundStatement/platformReconciliationDetail',
        component: () => import('@/views/iPayment/fundStatement/platformReconciliation/reconciliationDetail')
    },
    {
        path: 'iPayment/orderMan',
        redirect: 'iPayment/orderMan/paymentOrderIndex'
    },
    // 支付订单
    {
        path: 'iPayment/orderMan/paymentOrderIndex',
        component: () => import('@/views/iPayment/orderMan/payOrder/paymentOrderIndex'),
        meta: {
            isCached: true
        }
    },
    {
        path: 'iPayment/orderMan/paymentOrderInfo',
        component: () => import('@/views/iPayment/orderMan/payOrder/paymentOrderInfo')
    },
    {
        path: 'iPayment/orderMan/refundOrderIndex',
        component: () => import('@/views/iPayment/orderMan/payOrder/refundOrderIndex'),
        meta: {
            isCached: true
        }
    },
    {
        path: 'iPayment/orderMan/refundOrderInfo',
        component: () => import('@/views/iPayment/orderMan/payOrder/refundOrderInfo')
    },
    {
        path: 'iPayment/noticeRecord',
        redirect: 'iPayment/noticeRecord/payNotice'
    },
    // 支付通知
    {
        path: 'iPayment/noticeRecord/payNotice',
        component: () => import('@/views/iPayment/noticeRecord/payNotice'),
        meta: {
            isCached: true
        }
    },
    // 业务通知
    {
        path: 'iPayment/noticeRecord/businessNotice',
        component: () => import('@/views/iPayment/noticeRecord/businessNotice'),
        meta: {
            isCached: true
        }
    },
    {
        path: 'iPayment/outgoingManagement/outgoingManagementIndex',
        component: () => import('@/views/iPayment/outgoingManagement/outgoingManagementIndex')
    },
    {
        path: 'iPayment/outgoingManagement/outgoingManagementInfo',
        component: () => import('@/views/iPayment/outgoingManagement/outgoingManagementInfo')
    },
    {
        path: 'iPayment/outgoingManagement/newoutgoingManagementIndex',
        component: () => import('@/views/iPayment/outgoingManagement/newoutgoingManagementIndex')
    },
    {
        path: 'iPayment/outgoingManagement/newoutgoingManagementInfo',
        component: () => import('@/views/iPayment/outgoingManagement/newoutgoingManagementInfo')
    },
    {
        path: 'iPayment/transactionFlow/transactionFlow',
        component: () => import('@/views/iPayment/transactionFlow/transactionFlow')
    },
    //userManualIndex
  {
    path: 'iPayment/platformmerchant/platformmerchantindex',
    component: platformmerchantindex
  },
  {
    path: 'iPayment/platformmerchant/platformmerchantadd',
    component: platformmerchantadd
  },
  {
    path: 'iPayment/platformmerchant/platformmerchanteidt',
    component: platformmerchanteidt
  },
  {
    path: 'iPayment/platformmerchant/platformmerchantlist',
    component: platformmerchantlist
  },
  {
    path: 'iPayment/platformmerchant/merchantstatistics',
    component: merchantstatistics
  },
  {
    path: 'iPayment/platformmerchant/merchantstatisticslist',
    component: merchantstatisticslist
  },
  {
    path: 'iPayment/platformmerchant/cashoutreconciliation',
    component: cashoutreconciliation
  },
  {
    path: 'iPayment/platformmerchant/cashoutreconciliationinfo',
    component: cashoutreconciliationinfo
  },
  {
    path: 'iPayment/appInsert/appInsertIndex',
    component: appInsertIndex
},

{
    path: 'iPayment/schoolManage/schoolList',
    component: schoolList,
    meta: {
        isCached: true
    }
},
{
    path: 'iPayment/schoolManage/schoolListAbc',
    component: schoolListAbc,
    meta: {
        isCached: true
    }
},
{
    path: 'iPayment/schoolManage/schoolListCcb',
    component: schoolListCcb,
    meta: {
        isCached: true
    }
},
{
    path: 'iPayment/schoolManage/schoolAdd',
    component: schoolAdd
},
{
    path: 'iPayment/schoolManage/schoolEdit',
    component: schoolEdit
},
{
    path: 'iPayment/schoolManage/schoolDetail',
    component: schoolDetail
},
{
    path: 'iPayment/schoolManage/schoolPermission',
    component: schoolPermission
},
{
    path: 'iPayment/schoolManage/schoolGrant',
    component: schoolGrant
},
{
    path: 'iPayment/schoolManage/newOrderList',
    component: newOrderList
},
{
    path: 'iPayment/schoolManage/schoolIntGrant',
    component: schoolIntGrant
},
{
    path: 'iPayment/schoolManage/activatingCodeList',
    component: activatingCodeList
},
{
    path: 'iPayment/schoolManage/externalContact',
    component: externalContact
},
{
    path: 'iPayment/schoolManage/schoolModuleRolePermission/schoolModuleRolePermissionList',
    component: schoolModuleRolePermissionList,
    meta: {
        isCached: true
    }
},
{
    path: 'iPayment/schoolManage/schoolModuleRolePermission/schoolModuleRolePermissionAdd',
    component: schoolModuleRolePermissionAdd
},
{
    path: 'iPayment/schoolManage/schoolModuleRolePermission/schoolModuleRolePermissionEdit',
    component: schoolModuleRolePermissionEdit
},
{
    path: 'iPayment/schoolManage/schoolRole/schoolRoleList',
    component: schoolRoleList
},
{
    path: 'iPayment/schoolManage/schoolRole/schoolRoleEdit',
    component: schoolRoleEdit
},
{
    path: 'iPayment/schoolManage/schoolRole/schoolRoleUserList',
    component: schoolRoleUserList
},
{
    path: 'iPayment/schoolManage/schoolAppManage/schoolAppList',
    component: schoolAppList,
    meta: {
        isCached: true
    }
},
{
    path: 'iPayment/schoolManage/schoolAppManage/schoolAppInteDetail',
    component: schoolAppInteDetail
},
{
    path: 'iPayment/schoolManage/schoolAdmin',
    component: schoolAdmin
},
{
    path: 'iPayment/schoolManage/schoolSuite',
    component: schoolSuite
},
{
    path: 'iPayment/schoolManage/promoteGrade',
    component: promoteGrade
}
];



// WEBPACK FOOTER //
// ./src/router/modules/iPayment.js